import {
  WarehouseEvents
} from "@/services/warehouse.service";

const state = {
  selectedRange: null,
  search: {
    issue_date: null
  },
  deliveries: [],
  types: {
    pz: "Przyjęcie zewnętrzne",
    zpz: "Zwrot przyjęcia zewnętrznego"
  }
};

const getters = {
  search: state => {
    return state.search;
  },
  deliveries: state => {
    return state.deliveries;
  },
  selectedRange: state => {
    return state.selectedRange;
  },
  types: state => {
    return state.types;
  },
};

const actions = {
  async doSearch({
    commit
  }, query) {
    query.type = 'pz,zpz';
    let deliveries = await WarehouseEvents.search(query);
    commit("deliveries", deliveries);
    return deliveries;
  },
  async create({
    commit
  }, form) {
    let delivery = await WarehouseEvents.create(form);
    commit('push', delivery);
    return delivery;
  },
  async remove({
    commit
  }, deliveryid) {
    await WarehouseEvents.remove(deliveryid);
    commit('remove', deliveryid)
    return;
  },
  async getDelivery({
    state
  }, id) {
    let response = await WarehouseEvents.get(id);
    state; //Tego nie usuwaj to tylko do wygłuszenia błedu 
    return response;
  }
};

const mutations = {
  search(state, {
    type,
    value
  }) {
    state.search[type] = value;
  },
  range(state, {
    selected,
    range
  }) {
    state.selectedRange = selected;
    state.search.issue_date = range;
  },
  deliveries(state, payload) {
    state.deliveries = payload;
  },
  push(state, payload) {
    state.deliveries.unshift(payload);
  },
  remove(state, id) {
    let issuanceIndex = state.deliveries.findIndex((item) => (item.id === id));
    if (issuanceIndex >= 0)
      state.deliveries.splice(issuanceIndex, 1)
  },
  reset(state) {
    state.deliveries = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};